import React from "react";
import { MdChevronRight } from "react-icons/md";
import { handleNavRoutings } from "../../../utils/constants/Navbar";
import { useSelector } from "react-redux";
import { appDeepLink } from "../../../utils/constants";
import { handleLogout } from "../../../utils/utils";
import CustomDrawer from "../../v3/components/Common/CustomDrawer";
import TrialWithDownloadCTA from "../TrialWithDownloadCTA";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import Cancel from "../../Icons/Navbar/Cancel";
import Link from "next/link";

const MobileSideNav = ({ openDrawer, setOpenDrawer }) => {
  const currentUser = useSelector((state) => state.currentUser?.currentUser);
  const isLoggedIn = currentUser?.id;
  const axiosPrivate = useAxiosPrivate();
  return (
    <CustomDrawer isOpen={openDrawer} handleClose={() => setOpenDrawer(false)}>
      <div className="!bg-black flex flex-col h-[calc(100vh-65px)]">
        {/* Header */}
        <div className="bg-[#141414] py-3 border-b border-[#292929]">
          <div className="flex justify-between items-center w-[95%] mx-auto px-1">
            <img
              src="/assets/headerlogo.webp"
              alt="seekho"
              className="w-[100px]"
            />
            <button onClick={() => setOpenDrawer(false)}>
              <Cancel className="w-[34px]" />
            </button>
          </div>
        </div>

        {/* Content & CTA Wrapper */}
        <div className="flex-1 flex flex-col justify-between overflow-y-auto">
          {/* Navigation Items */}
          <div className="text-[21px] font-lexend flex flex-col gap-y-4 px-3 mt-4">
            {isLoggedIn ? (
              <button
                onClick={() => handleLogout({ type: "", axiosPrivate })}
                className="no-underline text-[#B8B8B8] flex justify-between items-center border-b border-[#292929] pb-3 text-[16px]"
              >
                Logout
                <span>
                  <MdChevronRight className="text-[#B8B8B8] text-[24px]" />
                </span>
              </button>
            ) : (
              <Link href="/login">
                <a className="no-underline text-[#B8B8B8] flex justify-between items-center border-b border-[#292929] pb-3 hover:text-[#B8B8B8] text-[16px]">
                  Login
                  <span>
                    <MdChevronRight className="text-[#B8B8B8] text-[24px]" />
                  </span>
                </a>
              </Link>
            )}

            {handleNavRoutings()?.map(
              (item) =>
                item?.display && (
                  <Link key={item?.title} href={item?.link}>
                    <a className="flex justify-between items-center border-b border-[#292929] pb-3 no-underline hover:text-[#B8B8B8] text-[#B8B8B8]">
                      <span className="font-lexend text-[16px]">
                        {item?.title}
                      </span>
                      <MdChevronRight className="text-[24px]" />
                    </a>
                  </Link>
                )
            )}
          </div>

          <div className="w-full px-3 mb-[100px]">
            <TrialWithDownloadCTA
              deepLink={appDeepLink}
              onSection="Mobile Nav Side Navigation"
              mobileStatus="hamburger_CTA"
              ctaClassName="text-[14px] !bg-white bg-none !text-black border-none text-black"
            />
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default MobileSideNav;
